// 유저 프로필 관련 더미 데이터

/**
 * 유저 프로필 정보 더미 데이터
 */
export const userProfileDummyData = {
  success: true,
  data: {
    email: 'user@blbent.com',
    company: 'BLBENT',
    nickname: 'blbuser',
    phone: '01012345678',
    notificationSettings: {
      email: true,
      kakao: false
    }
  }
};

/**
 * 유저 프로필 업데이트 더미 응답
 */
export const updateUserProfileDummyData = {
  success: true,
  message: '회원 정보가 성공적으로 업데이트되었습니다.',
  data: {
    email: 'user@blbent.com',
    company: 'BLBENT',
    nickname: 'blbuser',
    phone: '010-1234-5678'
  }
};

/**
 * 알림 설정 업데이트 더미 응답
 */
export const updateNotificationSettingsDummyData = {
  success: true,
  message: '알림 설정이 성공적으로 업데이트되었습니다.',
  data: {
    email: true,
    kakao: false
  }
};
